import moment from 'moment';

export function formatDateTime (datetime) {
  return moment(datetime).format('YYYY-MM-DD [às] HH:mm');
}

export function formatDateTimeSmall(datetime) {
  return moment(datetime).format('DD/MM HH:mm');
}

export function formatDateTimeCaption (datetime) {
  return moment(datetime).format('YYYY-MM-DD [;] HH:mm');
}